module.exports = __webpack_public_path__ + "media/images/play-1e86f8f8ea5b09ebdcd4b1902c2200e1.svg";